import { useCallback } from 'react';
import { ParteRepresentada } from '../interfaces';
import { MapaProcesso } from './types';
import { List, ListItemRepresentada, DeleteButton, Badge, IconContainerRepresentada, ParteInfoRepresentada } from './styles';
import { IconUser } from '../../../../../icons';
import { Trash2 } from 'lucide-react';

interface PartesRepresentadasListProps {
    partes: ParteRepresentada[];
    mapaProcesso: MapaProcesso;
    isEditing: boolean;
    isDisabled: boolean;
    onExcluir: (id: number, nome: string) => void;
}

const LinkIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 13a5 5 0 007.07 0l2.83-2.83a5 5 0 10-7.07-7.07L10 5"
            stroke="#16A34A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14 11a5 5 0 00-7.07 0L4.1 13.83a5 5 0 007.07 7.07L14 19"
            stroke="#16A34A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function PartesRepresentadasList({
    partes,
    mapaProcesso,
    isEditing,
    isDisabled,
    onExcluir
}: PartesRepresentadasListProps) {
    const handleExcluir = useCallback((parte: ParteRepresentada) => {
        if (!isDisabled) {
            onExcluir(parte.id_parte_representada, parte.nome);
        }
    }, [isDisabled, onExcluir]);

    if (partes.length === 0) {
        return <div className="nao-encontrado">Nenhuma parte adicionada</div>;
    }

    return (
        <List>
            {partes.map((parte) => {
                const vindaDeParte = parte.id_parte_processo !== null;
                const qualificacaoVinculada = vindaDeParte && mapaProcesso[parte.id_parte_representada];

                return (
                    <ListItemRepresentada key={parte.id_parte_representada}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                            <IconContainerRepresentada>
                                <IconUser color="#16A34A" />
                            </IconContainerRepresentada>
                            <ParteInfoRepresentada>
                                <span>{parte.nome}</span>
                                {qualificacaoVinculada && (
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '4px', 
                                        marginTop: '4px',
                                        fontSize: '0.75rem',
                                        color: 'var(--c16a34a)',
                                        fontWeight: 400
                                    }}>
                                        <LinkIcon />
                                        <span>Vinculada ao {qualificacaoVinculada}</span>
                                    </div>
                                )}
                            </ParteInfoRepresentada>
                        </div>
                        {isEditing && (
                            <div>
                                <DeleteButton
                                    onClick={() => handleExcluir(parte)}
                                    disabled={isDisabled}
                                >
                                    <Trash2 size={14} />
                                </DeleteButton>
                            </div>
                        )}
                    </ListItemRepresentada>
                );
            })}
        </List>
    );
}

